import { useEffect } from "react";

import useGetData from "../../../CustomHooks/useAxios/useGetData";
import DialogBox from "../../../components/UI/DialogBox";
import { handleErrMessage } from "../../../functions/handleErrMessage";
import spin from "../../../assets/icons/spin.png";
import {
  UPDATE_USER_ROLE_SETUP,
  UPDATE_USER_ROLE,
} from "../apiEndpoints";
import MainPageLayout from "../../../layout/MainPageLayout";
import UpdateRolesForm from "../form/UpdateRolesForm";
import usePatchData from "../../../CustomHooks/useAxios/usePatchData";

const UpdateUserRolePage = () => {
  const { data, isLoaded, error, getData } = useGetData();
  const { executePatch, loading, successResponse, formError, setFormError } =
    usePatchData();

  useEffect(() => {
    getData(UPDATE_USER_ROLE_SETUP);
  }, []);

  // execute post api
  const sendData = async (formValues, updateStateOnResponse) => {
    executePatch(formValues, UPDATE_USER_ROLE, updateStateOnResponse);
  };
  return (
    <MainPageLayout headerConfig={{ title: "Update User Roles" }}>
      {isLoaded && !error ? (
        <UpdateRolesForm
          rolesSetup={data}
          sendData={sendData}
          isSucceed={successResponse}
          loading={loading}
        />
      ) : error ? (
        <DialogBox
          title="Error"
          message={handleErrMessage(error)}
          isErrorHandleButtons={true}
        />
      ) : (
        <DialogBox message="Loading your data" animateIcon={spin} />
      )}
      {formError && (
        <DialogBox
          title="Error"
          btnText="Ok"
          message={handleErrMessage(formError)}
          closeAction={() => setFormError("")}
        />
      )}
    </MainPageLayout>
  );
};
export default UpdateUserRolePage;
